import { FontIcon, FontIcons, OnlyForScreenReader, StandardLink } from '@brandfolder/react';
import React, { FunctionComponent } from 'react';

import { I18nProviderWrapper } from '@components/common/I18nProviderWrapper';
import { SettingsEnableDisable } from '@components/settings/shared/settings-enable-disable';

interface EnableMultiLanguageAssetDetails {
  defaultEnabled: boolean | null;
}

const MultiLanguageAssetDetails: FunctionComponent<EnableMultiLanguageAssetDetails> = ({
  defaultEnabled
}) => (
  <I18nProviderWrapper>
    <SettingsEnableDisable
      defaultEnabled={defaultEnabled || false}
      description={
        <StandardLink
          className="mlad-article-link"
          href="https://help.brandfolder.com/hc/en-us/articles/360048044553-Multi-Language-Asset-Details-and-Bulk-Translations"
          target="_blank"
        >
          <span className="mlad-article-link--underline">
            {bfTranslate('Learn more')}
          </span>
          <OnlyForScreenReader>{bfTranslate('Opens in a new tab')}</OnlyForScreenReader>
          <FontIcon aria-hidden icon={FontIcons.NewTab} />
        </StandardLink>
      }
      errorTitle={bfTranslate('Error updating Multi Language Asset Details setting. Please contact support.')}
      id='enable-multi-language-asset-details'
      successTitle={bfTranslate('Multi Language Asset Details setting updated!')}
      title={bfTranslate('Multi Language Asset Details')}
      updateResourceKey='multiLanguageAssetDetailsEnabled'
    />
  </I18nProviderWrapper>
);

export default MultiLanguageAssetDetails;
